import Button from '@/components/common/Button';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useRouter } from 'next/router';
const AccountDeletedContent = ({ popup = false, onClose = null }) => {
  const { t, lang } = useTranslation('review');
  const { t: t2 } = useTranslation('common');
  const router = useRouter();
  return (
    <div className="pt-12 text-center px-5">
      <div className="enki-heading-2xl pb-6">{t('accountDelete.deleted_title')}</div>
      <div className="enki-body-xl pb-12">{t('accountDelete.deleted_content')}</div>
      <Button
        type="primary"
        inline={false}
        className="max-w-[343px] mx-auto"
        onClick={() => {
          window.location.href = `/${lang}/account/signup`;
        }}>
        {t2('got_it')}
      </Button>
    </div>
  );
};

export default AccountDeletedContent;
